import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // Report the error back to Bubble
    if (window.reportErrorToBubble) {
        window.reportErrorToBubble(error.toString(), errorInfo.componentStack);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ padding: '20px', textAlign: 'center', color: '#e53e3e' }}>
          <h1>Something went wrong.</h1>
          <p>An error occurred in the diagram component.</p>
          <pre style={{ textAlign: 'left', background: '#fff0f0', padding: '10px', borderRadius: '5px' }}>
            {this.state.error && this.state.error.toString()}
          </pre>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary; 